module.exports = __webpack_public_path__ + "static/media/match-bg.cd5b0326.svg";